import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue'

export const pridelavaService = {
    load,loadOne,loadbykmgmid,loadbyds,loadbyemso,save,add,loadIdPoSezoni,loadOneKlicaj
    
};

function load(sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalci/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(pridelava => {
            // login successful if there's a jwt token in the response
            
            return pridelava;
        }).
        catch(error=>{
            console.log(error)
        });;
}

function loadIdPoSezoni(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/preteklasezonaid/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
       
}


function loadOne(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
       
}
function loadOneKlicaj(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/klicaj/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
       
}

function loadbykmgmid(kmgmid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/kmgmid/?kmgmid=${kmgmid}`, requestOptions)
        .then(handleResponse)
       
}

function loadbyds(ds) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/ds/?ds=${ds}`, requestOptions)
        .then(handleResponse)
       
}

function loadbyemso(emso) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/emso/?emso=${emso}`, requestOptions)
        .then(handleResponse)
       
}

function add(pridelovalec) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(pridelovalec)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/dodaj`, requestOptions).then(handleResponse);
}


function save(pridelovalec) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(pridelovalec)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/shrani`, requestOptions).then(handleResponse);
}
